<template>
  <div class="sample-list-session-item">
    <v-hover :close-delay='250' v-slot:default='{hover}'>
      <v-card :class='`transition-fast-in-fast-out pl-${hover ? 5 : 0}`'>
        <v-list-item :key='name'>
          <v-layout wrap>
            <v-tooltip top>
              <template v-if="type === '3x3'" v-slot:activator='{on}'><v-list-item-avatar v-on='on' tile size='50'><img src='../assets/333.png'></v-list-item-avatar></template>
              <template v-else-if="type === '3BLD'" v-slot:activator='{on}'><v-list-item-avatar v-on='on' tile size='50'><img src='../assets/333bld.png'></v-list-item-avatar></template>
              <template v-else-if="type === '3x3OH'" v-slot:activator='{on}'><v-list-item-avatar v-on='on' tile size='50'><img src='../assets/333oh.png'></v-list-item-avatar></template>
              <template v-else v-slot:activator='{on}'><v-list-item-avatar v-on='on' tile size='50'><img src='../assets/invalid.png'></v-list-item-avatar></template>
              <span>{{ type }}</span>
            </v-tooltip>
            <v-flex xs9 sm4>
              <v-list-item-content>
                <v-list-item-title>{{ name }}</v-list-item-title>
              </v-list-item-content>
            </v-flex>
            <v-flex xs6 sm3>
              <v-text-field placeholder='Password (not required)' type='password'></v-text-field>
            </v-flex>
            <v-flex xs6 sm2>
              <v-btn text rounded outlined @click='enterSession' style='border-color: unset !important'>Enter Session</v-btn>
            </v-flex>
          </v-layout>
        </v-list-item>
      </v-card>
    </v-hover>
  </div>
</template>

<script>
export default {
  name: 'sample-list-session-item',
  data () {
    return {}
  },
  methods: {
    enterSession () {
      this.$router.push({ path: `/sample-session` })
    }
  },
  props: {
    name: String,
    type: String
  }
}
</script>

<style scoped>
.v-btn {
  border-color: unset;
}

.v-list__tile {
  height: 88px
}
@media only screen and (max-width: 1080px) {
  .v-list__tile {
    height: 150px
  }
}
</style>
